import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';
import { useTranslation } from 'react-i18next';
import {
  editTeamCardsSelect,
  freezeMemberCardsSelect,
  freezeLeadCardsSelect,
  changeRoleCardsSelect,
} from '@utils/static';
import { RenderItemCardAction } from '@shared/ui/forms/select-render';

export default function CardsActionPicker({
  control,
  error,
  name,
  type,
  isTeamLead = false,
}) {
  const { t } = useTranslation();

  const options = {
    editTeam: { list: editTeamCardsSelect, label: 'team_lead_cards' },
    freezeMember: isTeamLead
      ? { list: freezeLeadCardsSelect, label: 'team_lead_cards' }
      : { list: freezeMemberCardsSelect, label: 'member_cards' },
    changeRole: { list: changeRoleCardsSelect, label: 'member_cards' },
  }[type];

  return (
    <BasicSelectInput
      label={t(options.label)}
      control={control}
      name={name}
      data={options.list}
      error={error}
      Render={RenderItemCardAction}
      isRequired
      cleanable={false}
      valueKey="value"
      labelKey="label"
    />
  );
}
